import React from "react";

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconTADefault = ({
  width = 24,
  height = 24,
  color = "#515C6C",
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.0918 12.0254C18.0205 12.0254 19.584 13.5889 19.584 15.5176C19.5839 16.2559 19.3539 16.9399 18.9629 17.5039L20.7676 19.3086C21.0112 19.5527 21.0114 19.9484 20.7676 20.1924C20.5237 20.4363 20.1279 20.436 19.8838 20.1924L18.0791 18.3877C17.5149 18.779 16.8304 19.0098 16.0918 19.0098C14.1634 19.0096 12.5997 17.446 12.5996 15.5176C12.5996 13.589 14.1633 12.0256 16.0918 12.0254ZM13.8311 4C14.176 4.0002 14.4559 4.28004 14.4561 4.625V9.29395H19.125C19.47 9.29405 19.7498 9.574 19.75 9.91895V11.3252C19.7499 11.6702 19.47 11.9501 19.125 11.9502C18.7799 11.9502 18.5001 11.6703 18.5 11.3252V10.5439H13.8311C13.4859 10.5439 13.2061 10.2641 13.2061 9.91895V5.25H10.0439V9.91895C10.0439 10.0846 9.97842 10.2441 9.86133 10.3613C9.74416 10.4785 9.58464 10.5439 9.41895 10.5439H4.75V13.7061H9.41895C9.76397 13.7062 10.0438 13.986 10.0439 14.3311V19H12.9248C13.2698 19.0001 13.5497 19.28 13.5498 19.625C13.5498 19.9701 13.2699 20.2499 12.9248 20.25H9.41895C9.07385 20.2499 8.79395 19.9701 8.79395 19.625V14.9561H4.125C3.95924 14.9561 3.79983 14.8897 3.68262 14.7725C3.5657 14.6553 3.50005 14.4966 3.5 14.3311V9.91895C3.5001 9.75351 3.56575 9.59462 3.68262 9.47754C3.79981 9.36045 3.95933 9.29395 4.125 9.29395H8.79395V4.625C8.79405 4.27997 9.07391 4.00009 9.41895 4H13.8311ZM16.0918 13.083C14.7477 13.0832 13.6582 14.1735 13.6582 15.5176C13.6583 16.8616 14.7478 17.951 16.0918 17.9512C17.436 17.9512 18.5263 16.8617 18.5264 15.5176C18.5264 14.1734 17.436 13.083 16.0918 13.083Z"
        fill={color}
        className="therapeutic-area-icon-fill"
      />
    </svg>
  );
};

IconTADefault.displayName = "TADefault";

export default IconTADefault;
